export enum StockTransferStatusEnum {
  PENDING = 'pending',
  RECEIVED = 'received',
  CANCELLED = 'cancelled',
}

export interface StockTransfer {
  id: number;
  code: string;
  warehouse_name: string;
  status: StockTransferStatusEnum;
  shipment_date: string | null;
  expected_arrival_date: string | null;
  received_date: string | null;
  created_by: number | null;
  created_by_name: string;
  lines_summary: string[];
}
